<template>
  <div
    class="promo-banner critical-component-hide"
    :style="`--autoscroll-timing: ${autoscroll.timing}s;`"
  >
    <span
      id="promo-banner-title"
      class="visually-hidden"
      v-text="$string('general.site_header.promo_banner')"
    />

    <splide
      class="promo-banner__list"
      :options="config"
    >
      <splide-slide
        v-for="(block, index) of blocks"
        :key="`promo-${index}`"
        class="promo-banner__list-item text-other-label-l"
      >
        <div
          v-if="autoscroll.enable"
          class="promo-banner__autoscroll-snap"
        />

        <span v-html="getBlockText(block.title)" />
      </splide-slide>
    </splide>
  </div>
</template>

<script>

/**
 * Vue: Promo banner (promo-banner)
 * -----------------------------------------------------------------------------
 * Promo banner template.
 * - Conditionally loaded when section has blocks using Liquid.
 * - Scroll-snap is used for basic scrolling, you will need to add the carousel
 *   functionality if this is required.
 *
 * @param {Object} autoscroll - Autoscroll settings.
 * @param {Array} blocks - Promo blocks.
 * @param {Object} liquid - Liquid section ID, used for theme editor events.
 *
 */

import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
  name: 'PromoBanner',

  components: {
    Splide,
    SplideSlide,
  },

  props: {
    autoscroll: {
      type: Object,
      default: () => ({
        enable: false,
        timing: 5,
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
    // Needed for theme editor events
    // eslint-disable-next-line vue/no-unused-properties
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      config: {
        type: 'fade',
        rewind: true,
        perPage: 1,
        autoplay: true,
        interval: this.autoscroll.timing * 1000,
        speed: 350,
        arrows: false,
        pagination: false,
        drag: true,
        keyboard: true,
        pauseOnHover: true,
        pauseOnFocus: true,
      },
    }
  },

  mounted() {
    cnvs.EventBus.emit('cnvs:update-site-header-height')
  },

  methods: {

    /**
     * Get block text.
     * - Applies text class to <a> elements.
     * @param {String} block - Block text.
     * @returns {String}
     */
    getBlockText(block) {
      return block
        .replaceAll('<a', '<a class="text-other-label-l"')
        .replaceAll('<strong', '<strong class="text-other-label-l"')
    },
  },
}
</script>

<style lang="scss">
@import './promo-banner';
@import '@/components/splide';
</style>
